import { FormikInput } from 'shared/components/FormikInput'
import { WrapperFormProfile } from 'shared/styles/GlobalStyle'
import { ContactsData } from '../../consts/SubOrganization/ContactsData'
import { FieldArray } from 'formik'
import React from 'react'
import { StyledAddButton } from 'features/Clients/ui/style'
import { Icon } from 'shared/components/Icons'
import { Flex } from 'shared/components/Flex'
import { Button } from 'shared/components/Button'
import { closeModal, openModal } from 'shared/redux/slice/modalSlice'
import { useDispatch } from 'react-redux'

// TODO: rework as it has been done for update profile page
export const OrgContactsDataInput = ({ contacts }: any) => {
    const dispatch = useDispatch()

    return (
        <WrapperFormProfile>
            <FieldArray name='contacts'>
                {({ push, remove }) => (
                    <>
                        <Flex
                            justifyContent='space-between'
                            alignItems='center'
                        >
                            <div className='title'>Контактное лицо</div>
                            <StyledAddButton
                                onClick={() =>
                                    push({
                                        surname: '',
                                        first_name: '',
                                        patronymic: '',
                                        phone: '',
                                        email: '',
                                    })
                                }
                            >
                                Добавить контактное лицо{' '}
                                <div className='icon-add'>
                                    {' '}
                                    <Icon name='plus' />
                                </div>
                            </StyledAddButton>
                        </Flex>

                        <div className='container'>
                            {contacts?.map((_: any, contactIndex: number) =>
                                ContactsData.map((data, index) => (
                                    <div className='row' key={index}>
                                        {data.map((item: any, index) => (
                                            <FormikInput
                                                required={item.required}
                                                key={index}
                                                name={`contacts[${contactIndex}].${item.name}`}
                                                label={item.label}
                                                placeholder={item.placeholder}
                                                type={item.type}
                                                maskConfig={item.maskConfig}
                                                className='inputForm'
                                                $afterIcon='clearInput'
                                            />
                                        ))}
                                        {contacts.length > 1 && (
                                            <Flex alignItems='end'>
                                                <Button
                                                    themeType='outline-2'
                                                    style={{
                                                        borderColor: '#FC3F1D',
                                                        background: '#FFF1EF',
                                                        width: '39px',
                                                        padding: 0,
                                                    }}
                                                    bgLoading='#FC3F1D'
                                                    onClick={e => {
                                                        e?.preventDefault()
                                                        dispatch(
                                                            openModal({
                                                                isOpen: true,
                                                                content: (
                                                                    <>
                                                                        Вы точно
                                                                        хотите
                                                                        удалить
                                                                        контактное
                                                                        лицо?
                                                                    </>
                                                                ),
                                                                config: {
                                                                    title: 'Вы точно хотите удалить?',
                                                                    btns: [
                                                                        {
                                                                            onClick:
                                                                                () => {
                                                                                    remove(
                                                                                        contactIndex,
                                                                                    )
                                                                                    dispatch(
                                                                                        closeModal(),
                                                                                    )
                                                                                },
                                                                            title: 'Да',
                                                                            active: true,
                                                                        },
                                                                        {
                                                                            onClick:
                                                                                () =>
                                                                                    dispatch(
                                                                                        closeModal(),
                                                                                    ),
                                                                            title: 'Нет',
                                                                            active: false,
                                                                        },
                                                                    ],
                                                                },
                                                            }),
                                                        )
                                                    }}
                                                >
                                                    <Icon name='delete' />
                                                </Button>
                                            </Flex>
                                        )}
                                    </div>
                                )),
                            )}
                        </div>
                    </>
                )}
            </FieldArray>
        </WrapperFormProfile>
    )
}
